import { render, staticRenderFns } from "./Disk.vue?vue&type=template&id=fa182f08&"
import script from "./Disk.vue?vue&type=script&lang=js&"
export * from "./Disk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports